import { render, staticRenderFns } from "./SingleItem.vue?vue&type=template&id=97e1d656&"
import script from "./SingleItem.vue?vue&type=script&lang=js&"
export * from "./SingleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bensz/src/FrontendStudios/plentyDevTool/stabiloVueTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e1d656')) {
      api.createRecord('97e1d656', component.options)
    } else {
      api.reload('97e1d656', component.options)
    }
    module.hot.accept("./SingleItem.vue?vue&type=template&id=97e1d656&", function () {
      api.rerender('97e1d656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/SingleItem.vue"
export default component.exports